import { Box, Button, Container, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { animated, useSpring } from "@react-spring/web";
import cover from "../../images/to-the-moon.webp";

export default function Banner() {
  const navigate = useNavigate();

  const springStyles = useSpring({
    loop: { reverse: false },
    from: { x: -400 },
    to: { x: 0 },
    config: { duration: 500 }
  });

  const springButtonStyles = useSpring({
    loop: { reverse: false },
    from: { y: 400 },
    to: { y: 0 },
    config: { duration: 500 }
  });

  const springImgStyles = useSpring({
    from: { x: 400 },
    to: { x: 0 },
    config: { duration: 500 }
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#f0f1f6",
        color: "black",
        pb: { xs: 3, md: 0 }
      }}
      className="banner"
    >
      <Container maxWidth="lg">
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                marginBottom: { xs: 3 },
                margin: "auto",
                h1: {
                  xs: { fontSize: 36 },
                  md: { fontSize: 48 },
                  lineHeight: 1,
                  color: "inherit"
                }
              }}
            >
              <animated.div style={springStyles}>
                <Typography variant="h1" sx={{ color: "#000" }}>
                  Build your Business with Smart Marketing Tools
                </Typography>
                <Typography variant="h4" sx={{ color: "#000" }}>
                  Turn more of your visitors into customers. KeywordsFly helps
                  with smart features that let you create beautiful,
                  high-performing marketing campaigns.
                </Typography>
              </animated.div>
              <animated.div style={springButtonStyles}>
                <Button
                  size="large"
                  sx={{ width: 400, maxWidth: "100%", mt: 4 }}
                  variant="contained"
                  onClick={() => navigate("/login")}
                >
                  Login
                </Button>
              </animated.div>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <animated.img style={springImgStyles} src={cover} alt="cover" />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
